export const lazyRetry = function <T>(componentImport: () => Promise<T>): Promise<T> {
	return new Promise<T>((resolve, reject) => {
		const hasRefreshed: boolean = JSON.parse(
			sessionStorage.getItem("retry-lazy-refreshed") || "false",
		);

		componentImport()
			.then((component: T) => {
				sessionStorage.setItem("retry-lazy-refreshed", "false");
				resolve(component);
			})
			.catch(error => {
				if (!hasRefreshed) {
					sessionStorage.setItem("retry-lazy-refreshed", "true");
					return window.location.reload();
				}
				reject(error);
			});
	});
};